<template>
  <modal @close="closeModal">
    <h4 slot="header">Compañía Carretera</h4>

    <form id="item_form" @submit.prevent="validate()" slot="body">
      <div class="md-layout">
        <label class="md-layout-item md-size-25 md-form-label">Nombre</label>
        <div class="md-layout-item">
          <md-field :class="validationClass('name')">
            <md-input
              data-vv-name="name"
              v-validate="modelValidations.name"
              v-model="updatedItem.name"
              type="text"
            ></md-input>
            <span class="md-helper-text">Ingrese Nombre de Compania Carretera</span>
            <error-indicator :valid="validField('name')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-25 md-form-label">Nombre Corto</label>
        <div class="md-layout-item">
          <md-field :class="validationClass('shortName')">
            <md-input
              data-vv-name="shortName"
              v-validate="modelValidations.shortName"
              v-model="updatedItem.shortName"
              type="text"
            ></md-input>
            <span class="md-helper-text">Ingrese Nombre Corto de Compañía</span>
            <error-indicator :valid="validField('shortName')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-25 md-form-label">Nombre Código</label>
        <div class="md-layout-item">
          <md-field :class="validationClass('codeName')">
            <md-input
              data-vv-name="codeName"
              v-validate="modelValidations.codeName"
              v-model="updatedItem.codeName"
              type="text"
            ></md-input>
            <span class="md-helper-text">Ingrese Nombre Código</span>
            <error-indicator :valid="validField('codeName')"></error-indicator>
          </md-field>
        </div>
      </div>

      <!-- <div class="md-layout">
                <label class="md-layout-item md-size-25 md-form-label"> Activo </label>
                <div class="md-layout-item">
                  <md-switch v-model="updatedItem.isActive"></md-switch>
                </div>
      </div>-->

      <ImageField :editedObject="updatedItem"></ImageField>
    </form>

    <div slot="footer">
      <md-button class="md-info md-round" type="submit" form="item_form">listo</md-button>
    </div>
  </modal>
</template>

<script>
import ImageField from "../../../components/Inputs/ImageField";
import ErrorIndicator from "@/components/Validation/ErrorIndicator";
import { watchTouchedProperties } from "@/utils";

const modelValidations = {
  name: {
    required: true,
  },
  shortName: {
    required: true,
  },
  codeName: {
    required: true,
  },
};

export default {
  components: {
    ImageField,
    ErrorIndicator,
  },

  props: {
    editedItem: Object,
  },

  data() {
    return {
      updatedItem: {},
      modelValidations,
    };
  },

  methods: {
    closeModal: function () {
      this.$emit("close");
    },

    validate() {
      const sendObject = {
        original: this.editedItem,
        updated: this.updatedItem,
      };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", sendObject);
        } else {
          this.$notify({
            message: "Llene Todos los campos Marcados",
            icon: "close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }
      });
    },
  },

  mounted() {
    this.updatedItem = { ...this.editedItem };
  },

  watch: {
    ...watchTouchedProperties("updatedItem", Object.keys(modelValidations)),
  },
};
</script>

<style lang="scss" scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Highwaycompany/editModal.vue